<template>
  <div class="detail">
    <div class="nav">
      <img
        class="back"
        src="../../../assets/workOrder/back.png"
        alt=""
        @click="onClickBack"
      />
      <p class="title">业务详情</p>
      <div></div>
    </div>
    <div class="head_info">
      <div class="info_li">
        <div class="info_name">船名</div>
        <div class="info_cen">{{ queryInfo.shipName }}</div>
      </div>
      <div class="info_li">
        <div class="info_name">航次</div>
        <div class="info_cen">{{ queryInfo.voyageNumbe }}</div>
      </div>
      <div class="info_li">
        <div class="info_name">mmsi</div>
        <div class="info_cen">{{ queryInfo.mmsi }}</div>
      </div>
      <div class="info_li">
        <div class="info_name">客户名称</div>
        <div class="info_cen">{{ queryInfo.carrierComp }}</div>
      </div>
      <div class="info_li">
        <div class="info_name">中转港</div>
        <div class="info_cen">{{ queryInfo.transitPort }}</div>
      </div>
      <div class="info_li">
        <div class="info_name">运输类型</div>
        <div class="info_cen">{{ queryInfo.shippingType }}</div>
      </div>
      <div class="info_li">
        <div class="info_name">始发港</div>
        <div class="info_cen">{{ queryInfo.origin }}</div>
      </div>
      <div class="info_li">
        <div class="info_name">目的地</div>
        <div class="info_cen">{{ queryInfo.liuXiang }}</div>
      </div>
      <div class="info_li">
        <div class="info_name">煤种</div>
        <div class="info_cen">{{ queryInfo.coalVariety }}</div>
      </div>
      <div class="info_li">
        <div class="info_name">水尺数/吨</div>
        <div class="info_cen">{{ queryInfo.staffGauge }}</div>
      </div>
      <div class="info_li">
        <div class="info_name">作业动态</div>
        <div class="info_cen">{{ queryInfo.taskStatus }}</div>
      </div>
      <div class="info_li">
        <div class="info_name">是否场地货</div>
        <div class="info_cen">
          {{
            queryInfo.cdType == 1 ? "是" : queryInfo.cdType == 0 ? "否" : "--"
          }}
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
export default {
  name: "orderDetail",
  data() {
    return {
      queryInfo: {},
    };
  },
  created() {
    this.queryInfo = JSON.parse(this.$route.query.info);
  },
  mounted() {},
  methods: {
    onClickBack() {
      this.$router.go(-1);
    },
  },
};
</script>
  
  <style lang="less" scoped>
.detail {
  min-height: 240px;
  height: calc(100vh);
  background-color: #eeeeee;
  .nav {
    height: 40px;
    display: flex;
    align-items: center;
    background-color: #44b1f9;

    .title {
      //   height: 16px;
      font-size: 16px;
      font-weight: 400;
      //   text-align: center;
      color: #ffffff;
      //   line-height: 16px;
      margin: 0 auto;
      // margin-left: -26px;
    }

    .back {
      width: 18px;
      height: 18px;
      margin-top: -2px;
      margin-left: 8px;
    }

    div {
      width: 18px;
      margin-right: 8px;
    }
  }
  .head_info {
    background-color: #fff;
    width: 94%;
    // height: calc(100vh - 40px);
    margin: 20px 3% 0;
    border-radius: 6px;
    padding: 10px;
    .info_li {
      height: 40px;
      display: flex;
      align-items: center;

      .info_name {
        width: 80px;
        height: 100%;
        line-height: 40px;
        font-size: 14px;
        color: #999;
      }
      .info_cen {
        width: flex;
        color: #666;
        height: 100%;
        line-height: 40px;
      }
    }
  }
}
</style>